import styles from "./previewFrame.css"

export const previewFrameClassName = styles.frame

export type PreviewFrameSize = "large" | "medium" | "small"

export const defaultPreviewFrameSize: PreviewFrameSize = "medium"

export const getPreviewFrameSizeClassName = (size: PreviewFrameSize) => {
  return styles[size]
}
